<template lang="pug">
	.section-actions-create(v-if="showed && Template.SelectedTemplate")
		.card
			.card-header
				i.fa.fa-edit
				span Create Section
			.card-body.collapse.show
				.form-horizontal

					.form-group(v-if="Template.SelectedTemplate.id === 8")
						.in-a-row
							label.col-form-label Parent
							select.custom-select.custom-select-sm(v-on:change="setSectionParent($event.target.value)")
								option(:selected="referenceSection === 'expanded'" :value="'expanded'") Expanded top
								option(:selected="referenceSection === 'collapsed'" :value="'collapsed'") Collapsed top
						label.col-form-label(for="prependedInput") Title of new section
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")

					.form-group(v-else-if="Template.SelectedTemplate.id === 10")
						.in-a-row
							label.col-form-label Parent
							select.custom-select.custom-select-sm(v-on:change="setSectionParent($event.target.value)")
								option(:selected="referenceSection === 'top'" :value="'top'") Top section
								option(:selected="referenceSection === 'left'" :value="'left'") Left section
								option(:selected="referenceSection === 'right'" :value="'right'") Right section
						label.col-form-label(for="prependedInput") Title of new section
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")

					.form-group(v-else-if="Template.SelectedTemplate.id === 11")
						.in-a-row
							label.col-form-label Parent
							select.custom-select.custom-select-sm(v-on:change="setSectionParent($event.target.value)")
								option(:selected="referenceSection === 'collapsed'" :value="'collapsed'") Floor section collapsed
								option(:selected="referenceSection === 'expanded'" :value="'expanded'") Floor section expanded
						label.col-form-label(for="prependedInput") Title of new section
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")

					.form-group(v-else)
						.in-a-row
							label.col-form-label Reference section
							select.custom-select.custom-select-sm(v-on:change="setTemplateSection($event.target.value)")
								option(v-for="section in templateSections" :selected="referenceSection === section" :value="section.id") {{section.title}}
						label.col-form-label(for="prependedInput") Title of new section
							.controls
								input.form-control(id="prependedInput" size="16" type="text" v-model="title")


					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="create()") Create
						button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Cancel
</template>

<script>

	import _ 					from 'lodash';

	import Screen 				from './../../mixins/screen';

	import { Template } 		from './../../services/Template';
	import { Section } 			from "../../services/Section";
	import { Metadata }			from "../../services/Metadata";
	import { Project }			from "../../services/Project";
	import { Asset }			from "../../services/Asset";

	export default {
		name: "SectionActionsCreate",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false
		},
		data() {

			this.Template = Template;

			return {
				sectionPlacement: 'fullscreen',
				title: ''
			}
		},
		methods: {
			collectData() {

				this.title = 'New Section';

				if (!Project.SelectedProject) return;

				this.sections = Object.values(Metadata.TemplateSectionsByTemplateId)[Template.SelectedTemplate.id];

				this.templateSections = Object.values(Metadata.TemplateSectionsByTemplateId[Template.SelectedTemplate.id] || {}).filter(section => section.codename !== 'background');
				if (Template.SelectedTemplate.id === 9) this.templateSections = [];

				this.referenceSection = this.templateSections.find(section => section.codename === 'fullscreen') || this.templateSections[0];

				if (Template.SelectedTemplate.id === 8) this.referenceSection = 'expanded';
				if (Template.SelectedTemplate.id === 10) this.referenceSection = 'top';
				if (Template.SelectedTemplate.id === 11) this.referenceSection = 'collapsed';
				if (Template.SelectedTemplate.id === 9) this.referenceSection = null;


				this.projectId = Project.SelectedProject.id;

			},

			setTemplateSection(id) {
				this.referenceSection = this.templateSections.find(section => section.id === parseInt(id)) || this.templateSections[0];
			},

			setSectionParent(parent) {
				this.referenceSection = parent;
			},

			selectTemplate(sectionCodename) {

				this.section = Section.SectionsByProjectByCodename[this.projectId][sectionCodename];

			},

			create() {

				if (!this.projectId) return;


				if (Template.SelectedTemplate.id === 8 || Template.SelectedTemplate.id === 10 || Template.SelectedTemplate.id === 11) {
					Server.sendToSocket({
						CreateNewSectionChild: {
							projectId: this.projectId,
							title: this.title,
							referenceSection: this.referenceSection
						}
					});
				} else {
					let metadataSectionId = this.referenceSection ? this.referenceSection.id : null;
					Server.sendToSocket({
						CreateNewSection: {
							projectId: this.projectId,
							title: this.title,
							metadataSectionId: metadataSectionId
						}
					});
				}

				this.projectId = null;
				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.section-actions-create
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 280px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.in-a-row
				display: flex
				flex-direction: row
				align-items: center
				padding: 2px 0

				label
					min-width: fit-content

				select
					margin-left: 15px
					width: auto

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

			.select-group
				padding-top: 5px

			select
				font-size: 14px
				color: white
				border: 1px solid #23282c
				background-color: #515b65

</style>

